export default __webpack_public_path__ + "static/media/beck.eebac1ae.jpg";